import { makeStyles } from '@material-ui/core';
import { stylesBase } from './base';

export const useStyles = makeStyles(theme => ({
  block: {
    ...stylesBase(theme).block,
    [theme.breakpoints.down('xs')]: {
      padding: '16px 24px',
      // width: '100%',
      // maxWidth: 560,
    },
  },
}));
